export default "__VITE_ASSET__BkHtNJW7__"